import * as Yup from 'yup';

export const forgotPasswordSchema = (langData) => {
  return Yup.object().shape({
    username: Yup.string().required(langData.emailRequired),
  });
};
